
// This function sanitises the product name to be used in the URL.
// Based on C# StringExtensions.SanitiseProductName
export const sanitiseProductName = (productName:string) => {
    let newName = productName.replace(/\+/g, "plus");
    newName = newName.replace(/--/g, "!");
    newName = newName.replace(/ /g, "-");
    newName = newName.replace(/!/g, "--");
    newName = newName.trim();
    newName = newName.toLowerCase();
    
    return newName;
}